const color = (value: any) => {
  return `hsla(${~~(value * 999999)},60%,60%,0.8)`;
};

export default color;
